module.exports = __webpack_public_path__ + "static/gallery_kerry_5_thumb-97e3b8d2f9758bf4113202d5f69ca1f4.jpg";